import { useState } from "react";

type Props = {
  onQualify: (qualified: boolean) => void;
};

const PrecalificacionForm = ({ onQualify }: Props) => {
  const [factura, setFactura] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    // regla de negocio
    if (factura === "mayor_15000") {
      onQualify(true);
    } else {
      onQualify(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-5 max-w-md">
      <div>
        <label className="block text-sm font-medium text-gray-700">
          Factura eléctrica mensual
        </label>
        <select
          required
          value={factura}
          onChange={(e) => setFactura(e.target.value)}
          className="mt-1 w-full border border-gray-300 rounded-lg px-3 py-2"
        >
          <option value="">Selecciona una opción</option>
          <option value="menor_10000">Menos de S/ 10,000</option>
          <option value="entre_10000_15000">S/ 10,000 – S/ 15,000</option>
          <option value="mayor_15000">Más de S/ 15,000</option>
        </select>
      </div>

      <button
        type="submit"
        className="bg-[#F28C00] text-white px-6 py-3 rounded-xl font-medium"
      >
        Continuar
      </button>
    </form>
  );
};

export default PrecalificacionForm;
